<script setup>
const WHATSAPP_NUMBER = '5491123682508';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
const TEXT_LINE_1 = '¿Tenés dudas?';
const TEXT_LINE_2 = 'Agendanos y escribinos por WhatsApp.';
</script>

<template>
    <a :href="WHATSAPP_URL" target="_blank" rel="noopener noreferrer" class="acara-support-btn"
        aria-label="Contactar soporte de ACARA por WhatsApp">

        <div class="support-text">
            <span class="text-title">{{ TEXT_LINE_1 }}</span>
            <span class="text-subtitle">{{ TEXT_LINE_2 }}</span>
        </div>

        <div class="icon-wrapper">
            <img src="@/assets/images/support/icon_acara_bot.png" alt="ACARA BOT" class="bot-image"
                @error="$event.target.style.display = 'none'" />
        </div>
    </a>
</template>

<style scoped>
.acara-support-btn {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 9999;
    display: flex;
    align-items: center;
    gap: 8px;
    text-decoration: none;
    background-color: transparent;
    cursor: pointer;
    
    will-change: transform;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    transform: translateZ(0);
    -webkit-font-smoothing: subpixel-antialiased;
    
    transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.acara-support-btn:hover {
    transform: scale(1.05) translateZ(0);
}

.support-text {
    background-color: #ffffff;
    color: #333333;
    padding: 8px 14px;
    border-radius: 20px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
    font-family: 'Arial', sans-serif;
    
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    line-height: 1.3;
}

.text-title {
    font-size: 14px;
    font-weight: 700;
    display: block;
}

.text-subtitle {
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
}

.icon-wrapper {
    width: 85px;
    height: 85px;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    filter: drop-shadow(0 2px 5px rgba(0,0,0,0.2));
    transform: translateZ(0);
}

.bot-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    image-rendering: -webkit-optimize-contrast;
    filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.3));
    transition: filter 0.3s ease;
}

.acara-support-btn:hover .bot-image {
    filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.4));
}

@media (max-width: 480px) {
    .support-text {
        display: none;
    }
    
    .icon-wrapper {
        width: 70px;
        height: 70px;
    }
}
</style>